import React, { useState } from "react";
import PropTypes from "prop-types";

import { UploadButton, TextField, CheckboxSet } from "..";

import "./style.scss";

const fieldElement = ({ question, field }) => {
  var element;

  if (field.type === "input_text" || field.type === "textarea") {
    element = (
      <TextField
        name={field.name}
        placeholder={question.required ? `*${question.label}` : question.label}
        multi={field.type == "textarea"}
        required={question.required}
      />
    );
  } else if (field.type === "input_file") {
    element = (
      <UploadButton
        name={field.name}
        placeholder={question.required ? `*${question.label}` : question.label}
        required={question.required}
      />
    );
  } else if (
    field.type === "multi_value_single_select" ||
    field.type === "multi_value_multi_select"
  ) {
    element = (
      <CheckboxSet
        name={field.name}
        title={question.required ? `*${question.label}` : question.label}
        multi={field.type == "multi_value_multi_select"}
        items={field.values.map((value) => {
          return {
            value: value.value,
            label: value.label,
          };
        })}
      />
    );
  }

  return element;
};

const FormElement = (props) => {
  const [fieldIndex, setFieldIndex] = useState(0);

  const fields = props.question.fields;

  if (fields[fieldIndex] && fields[fieldIndex].type) {
    const field = fields[fieldIndex];
    const element = fieldElement({ question: props.question, field });

    return (
      <div className="FormElement">
        <div className="main-field">
          <element.type {...element.props} {...props}>
            {React.Children.toArray(element.props.children)}
          </element.type>
        </div>
      </div>
    );
  }
};

FormElement.propTypes = {
  question: PropTypes.object,
};

export default FormElement;
